import { runTransaction, doc, setDoc } from "firebase/firestore";
import { db } from "../../../config/firebase";

export async function obterProximoCodigoSequencialProcedimento(grupoId) {
  if (!grupoId) {
    throw new Error("grupoId é obrigatório para gerar o próximo código sequencial.");
  }

  const contadorRef = doc(db, "contadores", `procedimentos_${grupoId}`);

  

  // ✅ garante que o contador exista com grupoId (evita PERMISSION_DENIED no transaction.get quando o doc ainda não existe)
  await setDoc(contadorRef, { grupoId }, { merge: true });
const proximo = await runTransaction(db, async (transaction) => {
    const snap = await transaction.get(contadorRef);

    let atual = 0;
    if (snap.exists() && snap.data().ultimoCodigoSequencial != null) {
      atual = snap.data().ultimoCodigoSequencial;
    }

    const novoValor = atual + 1;

    transaction.set(
      contadorRef,
      { ultimoCodigoSequencial: novoValor, grupoId },
      { merge: true }
    );

    return novoValor;
  });

  return proximo;
}
